import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgStar32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M16 23.338 8.583 28l1.926-8.857L4 13.167l8.606-.812L16 4l3.394 8.355 8.606.812-6.509 5.976L23.417 28z" /></SvgIcon>;
};
const Memo = memo(SvgStar32);
export default Memo;